<template>
  <div class="license-error-container font">
    <div class="license-error-inner">
      <br />
      <h2>{{ $t("softwareNotUsed.title") }}</h2>

      <h3>
        {{
          $route.params.mode == 2
            ? $t("softwareNotUsed.disconnectMsgSingleUser")
            : $t("softwareNotUsed.disconnectMsg")
        }}
      </h3>

      <div class="btn" style="margin: auto;" @click="connectAgain">
        {{ $t("softwareNotUsed.connectAgain") }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    async connectAgain() {
      location.href = window.location.protocol + "\\\\" + window.location.host;
    },
    log_out() {
      this.$socket.client.emit("logout");
    },
  },
  mounted() {
    this.log_out();
  },
};
</script>

<style lang="scss" scoped>
.license-error-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  text-align: center;
  background-color: #f7f7f7;
}
h1 {
  margin: 0;
  font-size: 35px;
  font-weight: bolder;
}
h2 {
  font-size: 35px;
  margin-top: 17px;
  font-weight: normal;
}
.error-code {
  color: var(--custom-color1);
  border-top: 1px solid;
  border-bottom: 1px solid;
  display: flex;
  align-items: center;
  width: fit-content;
  height: 40px;
  justify-content: center;
  align-items: center;
  margin: 0 auto 50px auto;
  font-size: 20px;
}
.contact {
  font-size: 16px;
}
</style>
